export const RANGE_SEPARATOR = ' - ';
export const INPUT_MASK = '__/__/__';
export const RANGE_INPUT_MASK = `${INPUT_MASK}${RANGE_SEPARATOR}${INPUT_MASK}`;

export enum FILTER_RELATIVE_DATE_RANGE {
  LAST_24HRS = 'LAST_24HRS',
  LAST_7DAYS = 'LAST_7DAYS',
  LAST_30DAYS = 'LAST_30DAYS',
  LAST_90DAYS = 'LAST_90DAYS',
}

export const RELATIVE_DATE_RANGE_LABELS: Record<FILTER_RELATIVE_DATE_RANGE, string> = {
  [FILTER_RELATIVE_DATE_RANGE.LAST_24HRS]: 'Within last 24 hours',
  [FILTER_RELATIVE_DATE_RANGE.LAST_7DAYS]: 'Within last week',
  [FILTER_RELATIVE_DATE_RANGE.LAST_30DAYS]: 'Within last month',
  [FILTER_RELATIVE_DATE_RANGE.LAST_90DAYS]: 'Within last 90 days',
};

export const DATE_FORMATS = {
  MONTH_ABBR_DATE: 'dd MMM yy',
  YEAR_MONTH_DAY: 'yyyy-MM-dd',
  TIME: 'hh:mm a',
  DATE_TIME: 'dd MMM yy, hh:mm a',
  MONTH_YEAR: 'MMMM yyyy',
  MONTH_YEAR_MLA: 'MMM yyyy',
  MONTH_DAY_YEAR: 'MM/dd/yy',
};
